import React from "react";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import SimpleTemplateTitle from "@insightfulscience/atomic-react/SimpleTemplate/Title";
import SimpleTemplateDescription from "@insightfulscience/atomic-react/SimpleTemplate/Description";
import { string } from "prop-types";
import propsResolver from "@insightfulscience/shared-utils/fn/props-resolver";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import FreeTrialForm from "@src/FreeTrialForm";
import SiteLayout from "@src/SiteLayout";
import WithMaintenance from "@src/Maintenance/WithMaintenance";
import WithServices from "@src/services";
import resources from "../../locales/free-trial-page";

const FreeTrial = ({ expired }) => {
	const [t] = useLocale("free-trial");
	return (
		<SiteLayout>
			<PageMeta title={t("META.TITLE")} description={t("META.DESCRIPTION")}>
				<PageMeta.OGP
					locale={t("META.LOCALE")}
					type={t("META.TYPE")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					url={t("META.URL")}
					image={t("META_IMAGE")}
					imageSecureUrl={t("META_IMAGE_SECURE")}
					siteName={t("META.SITE_NAME")}
					articlePublisher={t("META.ARTICLE_PUBLISHER")}
					isImageBaseUrl
				/>
				<PageMeta.Canonical href={t("META.CANONICAL")} />
				<PageMeta.Twitter
					card={t("META.TWITTER_CARD")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					site={t("META.TWITTER_SITE")}
					creator={t("META.TWITTER_CREATOR")}
					image={t("META_TWITTER_IMAGE")}
					isImageBaseUrl
				/>
			</PageMeta>
			<SimpleTemplate>
				<SimpleTemplateTitle className="px-3" data-qa-selector="free-trial-main-heading">
					{t("TITLE")}
				</SimpleTemplateTitle>
				<SimpleTemplateDescription data-qa-selector="free-trial-description-paragraph">
					{t("SUB_TITLE")}
				</SimpleTemplateDescription>
				<FreeTrialForm trialTokenExpired={expired} key={Math.random()} />
			</SimpleTemplate>
		</SiteLayout>
	);
};

const expired = ({ query }) => query.expired;

FreeTrial.propTypes = {
	expired: string,
};

FreeTrial.getInitialProps = propsResolver({
	expired,
});

export default pipe(
	FreeTrial,
	WithLocale({ resources }),
	WithServices,
	WithMaintenance({ level: "NEW_ECOMM_AND_SIGNUPS" }),
);
